import { savePDF } from '@progress/kendo-react-pdf';

class DocService {
  createPdf = (html) => {
    savePDF(html, { 
    //   paperSize: 'Letter',
      fileName: 'invoice.pdf',
      margin: 30,
      fontSize : 12
    })
  }

  createComparePdf = (html) => {
    savePDF(html, { 
    //   paperSize: 'Letter',
      fileName: 'invoice.pdf',
      margin: 150,
      fontSize : 12
    })
  }
}

const Doc = new DocService();
export default Doc;


// WEBPACK FOOTER //
// ./src/components/bewise/Transaction/DocService.js